const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Account = () => import("@/views/tongluaccount");

// 详情

const Details = () => import("@/views/tongluaccount/details.vue");
const PossessionDetails = () => import("@/views/tongluaccount/components/major_possession_details.vue");



export default [
    {
        path: "/tongluList",
        name: "tongluList",
        component: Main,
        meta: {
            name: "桐庐统计信息",
            unfold: false, //是否可以被展开
            iconType: "usergroup-add"
        },
        redirect: {
            name: "tongluList"
        },
        children: [
            {
                path: "tongluList",
                name: "tongluList",
                component: Account,
                meta: {
                    name: "统计信息",
                    role: {},
                },
                children: [
                    {
                        path: "accountDetails",
                        name: "accountDetails",
                        component: Details,
                        meta: {
                            name: "统计信息/订单详情",
                            role: {},
                        }
                    },
                    // 大件回收订单详情
                    {
                        path: "PossessionDetails",
                        name: "PossessionDetails",
                        component: PossessionDetails,
                        meta: {
                            name: "大件回收订单/详情",
                            role: {},
                        }
                    }
                ]
            },

        ]
    }
];